import {defineMessages} from 'react-intl';

export default defineMessages({
	day: {
		id: 'birthday.day.placeholder',
		defaultMessage: 'Day'
	},
	month: {
		id: 'birthday.month.placeholder',
		defaultMessage: 'Month'
	},
	year: {
		id: 'birthday.year.placeholder',
		defaultMessage: 'Year'
	},
	invalid: {
		id: 'birthday.error.invalid',
		defaultMessage: 'Please enter the correct date',
	}
});